// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '엘앤씨바이오',
  targetSheetName: 'Sheet1',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '분류',
    '제품명',
    '성분 및 함량',
    '수수료',
    '약가',
    '급여구분',
    '보험코드',
    '비고',
  ],
});
